var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { ref: "appContainer", staticClass: "app-container" }, [
    _c(
      "div",
      { staticClass: "app-wrap" },
      [
        _c("AppHeader", {
          attrs: { isInTop: _vm.isInTop },
          on: { jumpToTarget: _vm.jumpToTarget }
        }),
        _vm._v(" "),
        _c("AppBanner"),
        _vm._v(" "),
        _c("AppBenifits"),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sale-more-bg" },
          [_c("AppSale"), _vm._v(" "), _c("AppMore")],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "recommend-faq-bg" },
          [_c("AppRecommend"), _vm._v(" "), _c("AppFaq")],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "language-switch dp-f" }, [
          _c(
            "span",
            {
              staticClass: "cn",
              on: {
                click: function($event) {
                  return _vm.switchLang("zh-CN")
                }
              }
            },
            [_vm._v("中文")]
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "en",
              on: {
                click: function($event) {
                  return _vm.switchLang("en")
                }
              }
            },
            [_vm._v("English")]
          )
        ]),
        _vm._v(" "),
        _c("Copyright"),
        _vm._v(" "),
        _c("FloatComponents"),
        _vm._v(" "),
        _c(
          "modal",
          {
            staticClass: "paid-modal",
            attrs: { closeable: false },
            model: {
              value: _vm.modalVisiable,
              callback: function($$v) {
                _vm.modalVisiable = $$v
              },
              expression: "modalVisiable"
            }
          },
          [
            _c("div", { attrs: { slot: "header" }, slot: "header" }),
            _vm._v(" "),
            _c("PaidModal"),
            _vm._v(" "),
            _c("div", { attrs: { slot: "footer" }, slot: "footer" })
          ],
          1
        ),
        _vm._v(" "),
        _vm.wechatVisable
          ? _c("WechatTip", { on: { closeWechatTip: _vm.closeWechatTip } })
          : _vm._e()
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }